import { Injectable, Injector } from '@angular/core';
import { OrderNote } from '@authority-labs/api-interfaces';
import { CrudService } from '../../shared/services/crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class OrderNotesService extends CrudService<OrderNote> {
  constructor(injector: Injector) {
    super(injector, 'ordernotes', OrderNote);
  }
}
